(ns practitest.frontend.testset2.subs
  (:require
   [practitest.frontend.subs :as subs]
   [re-frame.core :as re-frame]))

(def testset-index-state-key (:testset subs/index-grid-keys))
(def testset-instances-state-key (:testset-instances subs/index-grid-keys))

(re-frame/reg-sub
 ::module-state
 (fn [db _]
   (get-in db [:entity :testset :module-state] {})))

(re-frame/reg-sub
 ::add-instances-grid-state
 (fn [db _]
   (get-in db [:entity :testset :add-instances-state] {})))

(re-frame/reg-sub
 ::testset-instances-grid-state
 (fn [db _]
   (get-in db [:entity :testset :instances-state] {})))

(re-frame/reg-sub
 ::show-add-instances?
 (fn [_]
   (re-frame/subscribe [::add-instances-grid-state]))
 (fn [state _]
   (:show-add-instances? state)))

(def default-filter
  {:id   "_DEFAULT_"
   :name "All Tests"})

(re-frame/reg-sub
 ::filters
 (fn [_]
   (re-frame/subscribe [::add-instances-grid-state]))
 (fn [state _]
   (cons
    default-filter
    (:filters state))))

(re-frame/reg-sub
 ::tests
 (fn [_]
   (re-frame/subscribe [::add-instances-grid-state]))
 (fn [state _]
   (:data state)))

(re-frame/reg-sub
 ::testset-instances-current-page
 (fn [_]
   (re-frame/subscribe [::testset-instances-grid-state]))
 (fn [state _]
   (:current-page state)))

(re-frame/reg-sub
 ::testset-instances-total-count
 (fn [_]
   (re-frame/subscribe [::testset-instances-grid-state]))
 (fn [state _]
   (:total-count state)))

(re-frame/reg-sub
 ::testset-instances-full-data?
 (fn [_]
   (re-frame/subscribe [::testset-instances-grid-state]))
 (fn [state _]
   (:full-data? state)))

(re-frame/reg-sub
 ::add-instances-current-page
 (fn [_]
   (re-frame/subscribe [::add-instances-grid-state]))
 (fn [state _]
   (:current-page state)))

(re-frame/reg-sub
 ::add-instances-total-count
 (fn [_]
   (re-frame/subscribe [::add-instances-grid-state]))
 (fn [state _]
   (:total-count state)))

(re-frame/reg-sub
 ::add-instances-show-views?
 (fn [_]
   (re-frame/subscribe [::add-instances-grid-state]))
 (fn [state _]
   (:add-instances-show-views? state true)))

(re-frame/reg-sub
 ::selected-tests
 (fn [_]
   (re-frame/subscribe [::add-instances-grid-state]))
 (fn [state _]
   (:selection state)))

(re-frame/reg-sub
 ::instances-to-add
 (fn [db _]
   (get-in db [:entity :testset :module-state :instances-to-add])))

;; The one that user is selected
(re-frame/reg-sub
 ::current-filter-selected
 (fn [_]
   (re-frame/subscribe [::add-instances-grid-state]))
 (fn [state _]
   (:current-filter-selected state)))

(re-frame/reg-sub
 ::stale-grid?
 (fn [_]
   [(re-frame/subscribe [::subs/entity :testset])])
 (fn [[{:keys [stale-grid?]}] _]
   stale-grid?))

(re-frame/reg-sub
 ::current-tab
 (fn [db _]
   (get-in db [:entity :testset testset-index-state-key :current-tab])))

(re-frame/reg-sub
 ::testsets-instances-grid-state
 (fn [db _]
   (get-in db [:entity :testset :testsets-instances-grid] {})))

(re-frame/reg-sub
 ::instance-view-mode?
 (fn [db _]
   (or (get-in db [:entity :testset :instance-view-mode?] false)
       (get-in db [:entity :testsets-instances :instance-view-mode?] false))))

(re-frame/reg-sub
 ::testset-instances-full-data?
 (fn [_]
   (re-frame/subscribe [::testset-instances-grid-state]))
 (fn [state _]
   (:full-data? state)))

(re-frame/reg-sub
 ::testsets-instances-current-page
 (fn [_]
   (re-frame/subscribe [::testsets-instances-grid-state]))
 (fn [state _]
   (:current-page state)))

(re-frame/reg-sub
 ::testsets-instances-total-count
 (fn [_]
   (re-frame/subscribe [::testsets-instances-grid-state]))
 (fn [state _]
   (:total-count state)))

(re-frame/reg-sub
 ::testsets-instances-full-data?
 (fn [_]
   (re-frame/subscribe [::testsets-instances-grid-state]))
 (fn [state _]
   (:full-data? state)))

(re-frame/reg-sub
 ::linked-issues-state
 (fn [db _]
   (get-in db [:entity :testset :linked-issues-state] {})))

(re-frame/reg-sub
 ::linked-issues-data
 (fn [_]
   (re-frame/subscribe [::linked-issues-state]))
 (fn [state _]
   (:data state)))

(re-frame/reg-sub
 ::linked-issues-total-count
 (fn [_]
   (re-frame/subscribe [::linked-issues-state]))
 (fn [state _]
   (:total-count state)))

(re-frame/reg-sub
 ::linked-issues-current-page
 (fn [_]
   (re-frame/subscribe [::linked-issues-state]))
 (fn [state _]
   (:current-page state)))

(re-frame/reg-sub
 ::linked-issues-full-data?
 (fn [_]
   (re-frame/subscribe [::linked-issues-state]))
 (fn [state _]
   (:full-data? state)))